import {
  createAlgoliaInsightsPlugin
} from "@algolia/autocomplete-plugin-algolia-insights";
import insightsClient from "search-insights";

/**
 *
 */
const algoliaInsightsPlugin = createAlgoliaInsightsPlugin({ insightsClient });


export {
  algoliaInsightsPlugin,
}
